import React from "react";
import { ShoppingCart } from "lucide-react";
import { motion } from "framer-motion";

interface CartButtonProps {
  cartItemCount: number;
  onClick: () => void;
}

const CartButton: React.FC<CartButtonProps> = ({ cartItemCount, onClick }) => {
  const displayCount = cartItemCount > 9 ? "9+" : cartItemCount;

  return (
    <motion.button
      onClick={onClick}
      className="relative bg-white rounded-xl transition-all duration-300 px-2 py-1.5"
      whileTap={{ scale: 0.97 }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary to-secondary rounded-xl" />
      <div className="relative z-10 flex items-center justify-center">
        <ShoppingCart size={18} className="text-black" />
        {cartItemCount > 0 && (
          <span className="absolute -top-4 -right-3 flex items-center justify-center min-w-5 h-5 px-1 text-xs font-bold text-white bg-red-500 rounded-full shadow-md ring-2 ring-white/30">
            {displayCount}
          </span>
        )}
      </div>
    </motion.button>
  );
};

export default CartButton;